<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr','text-align':'right'}">
      <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-3 hover:text-primary cursor-pointer" v-if="this.params.showDetail" @click="showRecord" />
      <feather-icon icon="Edit2Icon" svgClasses="h-5 w-5 mr-3 hover:text-primary cursor-pointer" v-if="!this.params.hideEdit" @click="editRecord" />
      <feather-icon icon="TrashIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" v-if="!this.params.hideDelete && !(this.params.type == 'admin' && this.params.data.id == this.$store.state.AppActiveUser.id)" @click="deleteRecord" />
      <feather-icon icon="TrashIcon" svgClasses="h-5 w-5 text-gray" v-if="!this.params.hideDelete && (this.params.type == 'admin' && this.params.data.id == this.$store.state.AppActiveUser.id)" />
    </div>
</template>

<script>
import EventBus from '../../EventBus'

export default {
  name: 'CellRendererActions',
  methods: {
    editRecord () {
        EventBus.$emit('editRecord', this.params.data.id)
    },
    deleteRecord () {
       EventBus.$emit('deleteRecord', this.params.data.id)
    },
    showRecord () {
      EventBus.$emit('showRecord', this.params.data.id)
    },
  },
}
</script>
<style lang="scss" scoped>
.text-gray{
  color:darkgray;
}
</style>